/* PFC Up close — sections/pfc-moulding-upclose.liquid.
 * Shows the active moulding's corner + whole-frame renders for the build the
 * customer is looking at, following the customiser (pfc:upclose-state from
 * pfc-moulding.js). The build switch lets them flip without touching the
 * customiser; the next customiser change takes over again. */
(function () {
  var el = document.querySelector('[data-upclose]');
  var R = window.PFC_MOULDING;
  if (!el || !R || !R.mouldings || !R.mouldings.length) return;

  var mat = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) === 'USD';
  var M = mat ? 'mat' : 'mount';
  var LABEL = { STANDARD: 'Without ' + M, MOUNTED: 'With ' + M, GALLERY: 'Gallery', FLOAT: 'Float mount' };
  var CAP_CORNER = {
    STANDARD: 'The corner, glazed straight onto the artwork',
    MOUNTED: 'The corner, with a bevel-cut ' + M,
    GALLERY: 'The corner, with the white fillet holding the glazing off the artwork',
    FLOAT: 'The corner, with the print floating on a white backing'
  };
  var CAP_FRAME = { STANDARD: 'The whole frame, without a ' + M, MOUNTED: 'The whole frame, with a ' + M,
    GALLERY: 'The whole frame, gallery build', FLOAT: 'The whole frame, float mounted' };
  var ORDER = ['STANDARD', 'MOUNTED', 'GALLERY', 'FLOAT'];

  var elTitle = el.querySelector('[data-upclose-title]');
  var elLede = el.querySelector('[data-upclose-lede]');
  var elBuilds = el.querySelector('[data-upclose-builds]');
  var elCorner = el.querySelector('[data-upclose-corner]');
  var elFrame = el.querySelector('[data-upclose-frame]');
  var elCornerCap = el.querySelector('[data-upclose-corner-cap]');
  var elFrameCap = el.querySelector('[data-upclose-frame-cap]');
  var elSpecs = el.querySelector('[data-upclose-specs]');

  var current = { m: null, build: null };

  function mouldingById(id) {
    return R.mouldings.find(function (m) { return m.productId === id; }) || null;
  }
  function activeMoulding() {
    var s = R.upcloseState;
    return (s && mouldingById(s.mouldingId)) || mouldingById(R.activeMouldingId)
      || R.mouldings.find(function (m) { return m.isActive; }) || R.mouldings[0];
  }
  // Builds with a corner render (the corner leads); the frame falls back to the
  // lead frame when that build has no whole-frame view.
  function builds(m) {
    var c = (m.exampleImages && m.exampleImages.corner) || {};
    return ORDER.filter(function (b) { return c[b]; });
  }
  // The customiser's state -> the build to show.
  function buildFor(m, s) {
    var bs = builds(m);
    if (!bs.length) return null;
    var want = s && s.style === 'float' ? 'FLOAT'
      : s && s.style === 'gallery' ? 'GALLERY'
      : s && s.mount ? 'MOUNTED' : 'STANDARD';
    if (bs.indexOf(want) !== -1) return want;
    if (want === 'MOUNTED' && bs.indexOf('GALLERY') !== -1) return 'GALLERY';
    return bs[0];
  }
  function url(u, w) {
    if (!u) return '';
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function swap(img, src, alt) {
    if (!src || img.getAttribute('src') === src) { img.alt = alt; return; }
    img.classList.add('is-swapping');
    var pre = new Image();
    pre.onload = pre.onerror = function () {
      img.src = src; img.alt = alt;
      img.srcset = '';
      requestAnimationFrame(function () { img.classList.remove('is-swapping'); });
    };
    pre.src = src;
  }
  function name(m) { return String(m.productTitle || '').split(' / ')[0]; }
  function spec(dt, dd) { return '<div class="pfc-upclose__spec"><dt>' + dt + '</dt><dd>' + dd + '</dd></div>'; }
  function mm(n) { return Math.round(Number(n) * 10) / 10 + 'mm'; }

  function render(m, build) {
    var ex = m.exampleImages || {};
    var c = ex.corner || {}, f = ex.frame || {};
    var frameBuild = f[build] ? build : (ex.lead && ex.lead.frame) || Object.keys(f)[0];
    current = { m: m, build: build };
    elTitle.textContent = name(m);
    var deep = Number(m.filletDepthMm) > 0;
    elLede.textContent = deep
      ? 'A ' + mm(m.mouldingWidthMm) + ' face on a ' + mm(m.mouldingDepthMm) + ' deep profile. A white fillet inside the frame holds the glazing clear of the artwork.'
      : 'A ' + mm(m.mouldingWidthMm) + ' face on a ' + mm(m.mouldingDepthMm) + ' deep profile, cut, mitred and joined by hand.';
    swap(elCorner, url(c[build], 1500), name(m) + ' frame corner close-up, ' + (LABEL[build] || '').toLowerCase());
    swap(elFrame, url(f[frameBuild], 1200), name(m) + ' whole frame');
    elCornerCap.textContent = CAP_CORNER[build] || '';
    elFrameCap.textContent = CAP_FRAME[frameBuild] || '';
    var bs = builds(m);
    elBuilds.hidden = bs.length < 2;
    elBuilds.innerHTML = bs.map(function (b) {
      return '<button type="button" class="pfc-upclose__build" data-build="' + b + '" aria-pressed="' + (b === build) + '">' + LABEL[b] + '</button>';
    }).join('');
    var sp = spec('Face width', mm(m.mouldingWidthMm)) + spec('Depth', mm(m.mouldingDepthMm));
    if (m.mouldingFinish) sp += spec('Finish', m.mouldingFinish);
    if (deep) sp += spec('Fillet', mm(m.filletDepthMm) + ', white');
    if (m.material) sp += spec('Material', String(m.material).charAt(0).toUpperCase() + String(m.material).slice(1));
    elSpecs.innerHTML = sp;
    el.hidden = false;
  }

  function update(s) {
    var m = (s && mouldingById(s.mouldingId)) || activeMoulding();
    var b = m && buildFor(m, s || R.upcloseState);
    if (!m || !b) { el.hidden = true; return; }
    render(m, b);
  }

  elBuilds.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-build]');
    if (btn && current.m) render(current.m, btn.dataset.build);
  });
  document.addEventListener('pfc:upclose-state', function (e) { update(e.detail); });
  update(R.upcloseState || null);
})();
